/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Fw_Bm_MinutesInputs */

const en_fw_bm_minutes = /** @type {(inputs: Fw_Bm_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} min`)
};

const id_fw_bm_minutes = /** @type {(inputs: Fw_Bm_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} mnt`)
};

/**
* | output |
* | --- |
* | "{n} min" |
*
* @param {Fw_Bm_MinutesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_minutes = /** @type {((inputs: Fw_Bm_MinutesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_MinutesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_minutes(inputs)
	return en_fw_bm_minutes(inputs)
});